import { createSlice } from '@reduxjs/toolkit';
import { getWorkspaceApi } from '../server/workspace';

const initialWorkspaceState = {
    workspace: null,
    usersOptions: [],
    groupsOptions: [],
}

const workspaceSlice = createSlice({
    name: 'workspace',
    initialState: initialWorkspaceState,
    reducers: {
        updateWorkspace (state, actions) {
            state.workspace = actions.payload;
        },
        updateUsersOptions (state, actions) {
            state.usersOptions = actions.payload;
        },
        updateGroupsOptions (state, actions) {
            state.groupsOptions = actions.payload;
        }
    }
})

export const workspaceActions = workspaceSlice.actions;
export default workspaceSlice;

export const fetchWorkspace = () => {
    return async (dispatch) => {
        try {
            const res = await getWorkspaceApi();
            dispatch(workspaceActions.updateWorkspace(res.data ? res.data : null));

            const options = [];
            if(res.data && res.data.admin && res.data.admin._id){
                options.push({value: res.data.admin._id, label: res.data.admin.name, image: res.data.admin.profileImage, type: 'user'});
            }
            if(res.data && res.data.users && res.data.users.length > 0){
                for (let index = 0; index < res.data.users.length; index++) {
                    options.push({value: res.data.users[index]._id, label: res.data.users[index].name, image: res.data.users[index].profileImage, type: 'user'});
                }
            }
            dispatch(workspaceActions.updateUsersOptions(options));
            
            const gOptions = [];
            if(res.data && res.data.groups && res.data.groups.length > 0){
                for (let index = 0; index < res.data.groups.length; index++) {
                    gOptions.push({value: res.data.groups[index]._id, label: res.data.groups[index].name, image: res.data.groups[index].profileImage, type: 'group'});
                }
            }
            dispatch(workspaceActions.updateGroupsOptions(gOptions));
        } catch (err) {
            console.log('catch error: ', err);
        }
    }
}